<template>
  <section>
    <div class="container">
      <h1 class="is-size-2">Funciones</h1>
      <div class="columns">
        <div class="column">
          <div class="mb-2" v-if="Object.keys(errores_validacion).length !== 0">
            <b-message type="is-danger" has-icon>
              <div v-for="(item,index) in errores_validacion" :key='index'>
                <div v-if="item">{{ item }}</div>
              </div>
            </b-message>
          </div>
        </div>
      </div>

      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(updateFunctions)">
          <div class="columns">
            <div class="column">
              <b-field label="Búsqueda por nombre">
                <ValidationProvider :rules="{max: 255, regex: /^[0-9a-zA-ZáéíóúÁÉÍÓÚÑñ\s]*$/}" v-slot="{ errors }">
                  <b-input v-model="query" type="text"></b-input>
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field label="¿Es único?">
                <b-radio-button v-model="is_uniq"
                                :native-value="false"
                                type="is-danger is-light is-outlined">
                  <b-icon icon="times"></b-icon>
                  <span>No</span>
                </b-radio-button>

                <b-radio-button v-model="is_uniq"
                                :native-value="true"
                                type="is-success is-light is-outlined">
                  <b-icon icon="check"></b-icon>
                  <span>Si</span>
                </b-radio-button>

                <b-radio-button v-model="is_uniq"
                                :native-value="null"
                                type="is-primary is-light is-outlined">
                  Indefinido
                </b-radio-button>
              </b-field>
            </div>
            <div class="column">
              <b-field label="¿Es autoridad?">
                <b-radio-button v-model="is_authority"
                                :native-value="false"
                                type="is-danger is-light is-outlined">
                  <b-icon icon="times"></b-icon>
                  <span>No</span>
                </b-radio-button>

                <b-radio-button v-model="is_authority"
                                :native-value="true"
                                type="is-success is-light is-outlined">
                  <b-icon icon="check"></b-icon>
                  <span>Si</span>
                </b-radio-button>

                <b-radio-button v-model="is_authority"
                                :native-value="null"
                                type="is-primary is-light is-outlined">
                  Indefinido
                </b-radio-button>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="actions has-text-centered">
                <button class="button is-primary">Aplicar Filtro</button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <div class="columns is-centered" v-if="functions.length===1" style="margin-bottom: 40px; margin-top: 40px;">
        <div class="column is-6 is-centered has-text-centered">
          <b-message type="is-warning">
            Se encontró {{this.functions.length}} resultado.
          </b-message>
        </div>
      </div>
      <div class="columns is-centered" v-if="functions.length!==1" style="margin-bottom: 40px; margin-top: 40px;">
        <div class="column is-6 is-centered has-text-centered">
          <b-message type="is-warning">
            Se encontraron {{this.functions.length}} resultados.
          </b-message>
        </div>
      </div>
      <div class="has-text-right">
        <b-button type="is-info"
                  icon-left="plus"
                  v-if="can_create==='true'"
                  @click="newFunction()">
          Añadir Función
        </b-button>
      </div>
      <br>
      <b-table
          :data="functions"
          :paginated=true
          per-page=10
          style="word-break:break-all;"
          narrowed
          striped
          hoverable
          :card-layout="cardLayout"
          :current-page="currentPage"
          :pagination-simple=false
          pagination-position="bottom"
          default-sort-direction="desc"
          sort-icon="arrow-up"
          sort-icon-size="is-small"
          default-sort="function.name"
          aria-next-label="Siguiente"
          aria-previous-label="Anterior"
          aria-page-label="Página"
          aria-current-label="Página actual"
          :opened-detailed="defaultOpenedDetails"
          detailed
          detail-key="name"
          @details-open="(row) => $buefy.toast.open(`Expanded ${row.name}`)"
          :show-detail-icon="showDetailIcon"
      >
        <b-table-column
            field= 'name'
            label= 'Nombre'
            width="400"
            searchable
            sortable>
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{ props.row.name }}
          </template>
        </b-table-column>
        <b-table-column
            field= 'alt_name'
            label= 'Nombre Alternativo'
            width="400"
            searchable
            sortable>
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{ props.row.alt_name }}
          </template>
        </b-table-column>

        <b-table-column
            field= 'uniq'
            label= '¿Es único?'
            searchable
            width="150"
            sortable>
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{props.row.text_is_uniq}}
          </template>
        </b-table-column>

        <b-table-column
            field= 'is_authority'
            label= '¿Es autoridad?'
            searchable
            width="150"
            sortable>
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{props.row.text_is_authority}}
          </template>
        </b-table-column>
        <b-table-column
            label="Acciones"
            v-slot="props">
          <b-icon
              pack="fas"
              icon="eye"
              size="is-medium"
              type="is-success"
              v-if="props.row.can_show"
              @click.native="openShowModal(props.row.id)"/>
          <b-icon
              pack="fas"
              icon="edit"
              size="is-medium"
              type="is-info"
              v-if="props.row.can_edit"
              @click.native="openEditModal(props.row.id)"/>
          <b-icon
              v-if="props.row.can_nullify"
              pack="fas"
              icon="trash-alt"
              type="is-danger"
              size="is-medium"
              @click.native="verifyNullifyModal(props.row.id)"/>
        </b-table-column>

        <template slot="detail" slot-scope="props">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <p>
                  <strong>Función padre: </strong>
                  <span>{{props.row.parent_function}}</span>
                </p>
              </div>
            </div>
          </article>
        </template>

        <template slot="empty" slot-scope="props">
          <div class="columns is-centered">
            <div class="column is-6 is-centered has-text-centered">
              <b-message type="is-danger">
                No se encontraron resultados para los filtros seleccionados.
              </b-message>
            </div>
          </div>
        </template>
      </b-table>

      <b-modal
          v-model="isShowActive"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          :width="1080"
          aria-modal>
        <template #default="props">
          <function :id="selected"
                 :modal-header="'Función'"
                 @close="props.close">
          </function>
        </template>
      </b-modal>

      <b-modal
          v-model="isAddActive"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          :width="1080"
          aria-modal
          :can-cancel="canCancel">
        <template #default="props">
          <function-form :id="selected"
                    :modal-header="'Crear Función'"
                     :query-type="'create'"
                    @close="props.close">
          </function-form>
        </template>
      </b-modal>

      <b-modal
          v-model="isEditActive"
          has-modal-card
          trap-focus
          :width="1080"
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal
          :can-cancel="canCancel">
        <template #default="props">
          <function-form :id="selected"
                         :modal-header="'Editar Función'"
                         :query-type="'update'"
                         @close="props.close">
          </function-form>
        </template>
      </b-modal>

      <b-modal
          v-model="isConfirmNullify"
          has-modal-card
          trap-focus
          :width="1080"
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal
          :can-cancel="canCancel">
        <template #default="props">
          <modal-confirm-nullify :id="selected"
                         :modal-header="'Confirmar Anulación'"
                         :functions="replace_functions"
                         :num_person_functions="num_person_functions"
                         :num_person_units="num_person_units"
                         @close="props.close">
          </modal-confirm-nullify>
        </template>
      </b-modal>

      <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>

    </div>
  </section>
</template>
<script>
import axios from "axios";
import Function from "./function";
import FunctionForm from "./modal_function_form"
import ModalConfirmNullify from "./modal_confirm_nullify"
import EventBus from "../eventBus";
export default {
  name: "functions",
  props:[
    'cargoPrincipal', 'can_create'
  ],
  components: {
    Function,
    FunctionForm,
    ModalConfirmNullify
  },
  data(){
    return{
      isLoading:false,
      currentPage:1,
      cardLayout:false,
      defaultOpenedDetails: [1],
      showDetailIcon: true,
      isNullifyActive: false,
      functions: [],
      is_uniq: null,
      is_authority: null,
      errores_validacion: {},
      query: null,
      isAddActive: false,
      isEditActive: false,
      isShowActive: false,
      selected: null,
      canCancel: [],
      isConfirmNullify: false,
      num_person_functions: 0,
      num_person_units: 0,
      replace_functions: []
    }
  },
  created(){
    this.updateFunctions()
  },
  methods:{
    updateFunctions(){
      this.isLoading = true
      this.selected = null
      return axios.get("/functions/advanced-search.json", {params:{query:this.query, is_uniq:this.is_uniq, is_authority: this.is_authority}})
          .then(res => {
            this.functions = res.data
            this.isLoading=false;
          })
          .catch(error => {
            this.errores_validacion = error.response.data
            this.isLoading=false;

            //console.log(e);
          });
    },
    newFunction(){
      this.isLoading = true
      this.isAddActive = true
      this.isLoading = false
    },
    openEditModal(id){
      this.isLoading = true
      this.selected = id
      this.isEditActive = true
      this.isLoading = false
    },
    openShowModal(id){
      this.isLoading = true
      this.selected = id
      this.isShowActive = true
      this.isLoading = false
    },
    verifyNullifyModal(id){
      this.isLoading = true
      this.isNullifyActive = true
      this.selected = id
      axios
          .get("/functions/" + id + "/verify-nullify-function.json")
          .then(res => {
            this.isLoading = false;
            this.num_person_functions = res.data["num_person_functions"]
            this.num_person_units = res.data["num_person_units"]
            this.replace_functions = res.data["replace_functions"]
            this.isConfirmNullify = true
            this.isNullifyActive = false
          }).catch(error => {
        this.$buefy.dialog.alert({
          message: error.response.data["message"],
          duration: 5000,
          type: 'is-danger',
          canCancel: ["escape", "outside"]
        })
        this.isLoading = false;
        this.isNullifyActive = false;
      })
    },
  },
  watch:{
    isAddActive: function () {
      if (!this.isAddActive) {
        this.updateFunctions()
      }
    },
    isEditActive: function () {
      if (!this.isEditActive) {
        this.updateFunctions()
      }
    },
    isConfirmNullify: function () {
      if (!this.isConfirmNullify) {
        this.updateFunctions()
      }
    },
  },
  computed:{

  }
}
</script>